<template>
    <div class="payment-complete">
        <div>
            <div class="payment-complete-header">
                <img src="@/assets/green-check.png" alt="Check" :class="!this.$store.getters.isPrepayment ? 'small-icon' : ''">
                <p v-if="this.$store.getters.isPrepayment">
                    Your payment was successful!
                </p>
                <div v-else>
                    <p>
                        Your GeneSight test order is confirmed
                    </p>
                    <p class="collection-kit">
                        Your at-home collection kit will be shipped via FedEx. We will email updates along the way.
                    </p>
                </div>
            </div>
            <div class="payment-complete-content">
                <h1 v-if="this.$store.getters.isPrepayment">
                    Your collection kit will ship shortly. We'll email updates along the way.
                </h1>
                <h2 :class="!this.$store.getters.isPrepayment ? 'large' : ''">
                    What happens next?
                </h2>
                <div class="next-steps">
                    <div class="step-item">
                        <div class="image-wrapper">
                            <img src="@/assets/truck_icon.png" alt="Truck Icon" class="step-icon">
                        </div>
                        <h3 class="step-label">
                            Your kit is on its way
                        </h3>
                        <p class="step-description">
                            Your at-home collection kit will be shipped via FedEx.
                        </p>
                    </div>
                    <img src="@/assets/right_arrow_icon.png" alt="" class="step-arrow">
                    <div class="step-item">
                        <div class="image-wrapper">
                            <img src="@/assets/swab_icon.png" alt="Swab Icon" class="step-icon">
                        </div>
                        <h3 class="step-label">
                            Collect your sample
                        </h3>
                        <p class="step-description">
                            Follow the instructions included in your kit.
                        </p>
                    </div>
                    <img src="@/assets/right_arrow_icon.png" alt="" class="step-arrow">
                    <div class="step-item">
                        <div class="image-wrapper">
                            <img src="@/assets/kit_icon.png" alt="Kit Icon" class="step-icon">
                        </div>
                        <h3 class="step-label">
                            Return your kit
                        </h3>
                        <p class="step-description">
                            Use the prepaid return label included in your kit to send it back to the lab.
                        </p>
                    </div>
                    <img src="@/assets/right_arrow_icon.png" alt="" class="step-arrow">
                    <div class="step-item">
                        <div class="image-wrapper">
                            <img src="@/assets/result_icon.png" alt="Report Icon" class="step-icon">
                        </div>
                        <h3 class="step-label">
                            Results sent to your provider
                        </h3>
                        <p class="step-description">
                            Once our lab receives your kit, your results will be sent to your provider in approximately 3-5 days.
                        </p>
                    </div>
                </div>
                <div class="kit-arrival">
                    <div v-if="!this.$store.getters.isPrepayment" class="billing-info">
                        <img src="@/assets/billing-info-icon.png" alt="Info Icon">
                        <div class="billing-info__content">
                            <h3>
                                What to expect for billing
                            </h3>
                            <p>
                                The payment method you provided today will be charged for any remaining balance after your insurance is processed, typically within 60 days of your test being returned.
                            </p>
                        </div>
                    </div>
                    <div class="media-wrapper">
                        <img src="@/assets/gsah-page.png" alt="Kit Image">
                        <div class="kit-arrival__content">
                            <div class="kit-arrival__content-header">
                                Get ready before your kit arrives
                            </div>
                            <div class="kit-arrival__copy">
                                Explore videos, collection instructions, and FAQs to help you feel prepared before your kit arrives.
                            </div>
                            <a href="https://genesight.com/genesight-at-home/" target="_blank" class="kit-arrival__cta">
                                Visit Resource Center
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PaymentComplete",
    mounted() {
        this.$store.dispatch("setShowStartupLoader", false);
    }
};
</script>

<style lang="scss" scoped>
.payment-complete{
    @include site-section();
}

/* self pay */
.payment-complete-header {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 12px;
    background: var(--Color-green-deep-25, #F6FEF9);
    margin: 25px 0;
    color: var(--Color-green-deep-600, #099250);
    text-align: center;
    font-family: "Inter", "Raleway", sans-serif;
    font-size: var(--font-size-hs, 20px);
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    letter-spacing: -0.2px;

    img {
        width: 48px;

        &.small-icon {
            width: 33px;
        }
    }

    .collection-kit {
        font-size: var(--font-size-hm, 24px);
        font-style: normal;
        font-weight: 600;
        line-height: 133%; /* 31.92px */
        letter-spacing: -0.48px;
    }
}

.payment-complete-content {
    display: flex;
    padding: 32px 56px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid var(--Color-gray-200, #E3E8EF);
    margin-bottom: 35px;

    h1 {
        color: #000;
        text-align: center;
        font-family: "Inter", "Raleway", sans-serif;
        font-size: var(--font-size-hl, 32px);
        font-style: normal;
        font-weight: 600;
        line-height: 119%; /* 38.08px */
        letter-spacing: -0.64px;
    }

    h2 {
        color: var(--Color-blue-bright-500, #0691EF);
        text-align: center;
        font-family: "Inter", "Raleway", sans-serif;
        font-size: var(--font-size-hm, 24px);
        font-style: normal;
        font-weight: 600;
        line-height: 133%; /* 31.92px */
        letter-spacing: -0.48px;

        &.large {
            font-size: var(--font-size-hl, 32px);
            font-style: normal;
            font-weight: 600;
            line-height: 119%; /* 38.08px */
            letter-spacing: -0.64px;
        }
    }

    .next-steps {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        margin-top: 2rem;
        text-align: center;
    }

    .step-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .image-wrapper {
        display: flex;
        height: 81px;
        padding: 24px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        border-radius: 8px;
        background: #F6FBFF;
        margin-bottom: 16px;
    }

    .step-icon {
        width: 34px;
        height: auto;
        object-fit: contain;
    }

    .step-arrow {
        width: 30px;
        height: auto;
        margin-top: auto;
        margin-bottom: auto;
    }

    .step-label {
        align-self: stretch;
        color: var(--Color-blue-bright-500, #0691EF);
        text-align: center;
        font-family: "Inter", "Raleway", sans-serif;
        font-size: var(--font-size-tl, 18px);
        font-style: normal;
        font-weight: 600;
        line-height: 156%; /* 28.08px */
        letter-spacing: -0.18px;
        margin-bottom: 16px;
    }

    .step-description {
        align-self: stretch;
        color: #000;
        text-align: center;
        font-family: "Inter", "Raleway", sans-serif;
        font-size: var(--font-size-tl, 18px);
        font-style: normal;
        font-weight: 400;
        line-height: 156%; /* 28.08px */
        letter-spacing: -0.18px;
    }

    .kit-arrival__header {
        color: #000;
        text-align: center;
        font-family: "Inter", "Raleway", sans-serif;
        font-size: var(--font-size-hm, 24px);
        font-style: normal;
        font-weight: 500;
        line-height: 133%; /* 31.92px */
        letter-spacing: -0.48px;
        margin-bottom: 24px;
    }

    .billing-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 4px;
        background: var(--Color-blue-bright-25, #F6FBFF);
        padding: 24px;
        margin: 24px 0;

        img {
            width: 84px;
            margin-right: 24px;
        }

        .billing-info__content {

            h3 {
                color: var(--Color-blue-bright-500, #0691EF);
                font-family: var(--font-family-Inter, Inter);
                font-size: var(--font-size-hm, 24px);
                font-style: normal;
                font-weight: 600;
                line-height: 133%; /* 31.92px */
                letter-spacing: -0.48px;
                margin-bottom: 8px;
            }

            p {
                color: #000;
                font-family: var(--font-family-Inter, Inter);
                font-size: var(--font-size-tl, 18px);
                font-style: normal;
                font-weight: 400;
                line-height: 156%; /* 28.08px */
                letter-spacing: -0.18px;
            }
        }
    }

    .media-wrapper {
        display: flex;
        padding: 16px;
        align-items: center;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        background: var(--Color-gray-50, #F8FAFC);

        img {
            max-width: 350px;
        }

        .kit-arrival__content-header {
            color: #000;
            font-size: var(--font-size-tl, 18px);
            font-style: normal;
            font-weight: 600;
            line-height: 156%; /* 28.08px */
            letter-spacing: -0.18px;
            margin-bottom: 24px;
        }

        .kit-arrival__copy {
            color: #000;
            font-family: "Inter", "Raleway", sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 400;
            line-height: 156%; /* 28.08px */
            letter-spacing: -0.18px;
            margin-bottom: 24px;
        }

        .kit-arrival__cta {
            padding: 10px 18px;
            border-radius: 4px;
            border: 1px solid #003595;
            background: #FFF;
            text-decoration: none;
            color: #003595;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%;
            letter-spacing: -0.16px;
        }
    }

    .kit-arrival__info {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 16px;
        align-self: stretch;
        margin-top: 24px;

        .info-icon-wrapper {
            display: flex;
            width: 78px;
            height: 81px;
            padding: 24px;
            justify-content: center;
            align-items: center;
            gap: 10px;
            border-radius: 8px;
            background: var(--Color-blue-bright-50, #E2F1FC);

            img {
                width: 34px;
            }
        }

        .info-copy {
            color: #000;
            text-align: center;
            font-family: "Inter", "Raleway", sans-serif;
            font-size: var(--font-size-tl, 18px);
            font-style: normal;
            font-weight: 400;
            line-height: 156%; /* 28.08px */
            letter-spacing: -0.18px;

            a {
                color: var(--Color-blue-bright-500, #0691EF);
                text-decoration: none;
            }
        }
    }
}
/* end self pay */

.step-header-wrapper {
    max-width: 1164px;
    width: 100%;
    padding-top: 55px;
    margin: 0 auto 45px auto;
}

.step-header-title {
    width: 100%;
    font-size: 3em;
    font-weight: 700;
}

.header-content {
    display: flex;
    align-items: center;
    color: var(--Primary-Grey---Copy-Black, #333);
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 30px;
}

.header-image {
    width: 26px;
    margin-right: 15px;
}

.complete-content {
    margin-bottom: 30px;
    margin-left: 40px;
}

.green-header {
    color: var(--Primary-Primary-Green, #7AC142);
    font-size: 26px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px; /* 115.385% */
    margin-bottom: 10px;
}

.subtext {
    color: var(--Primary-Grey---Copy-Black, #333);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 137.5% */
    margin-left: 30px;
    margin-bottom: 20px;
}

@include small-desktop() {
    .payment-complete{
        @include site-section-sm-desktop();
    }

    .payment-complete-content {
        .next-steps {
            flex-direction: column;
            align-items: center;

            .step-arrow {
                rotate: 90deg;
                margin: 20px 0;
            }

            .step-item {
                max-width: 400px;

                .image-wrapper {
                    width: 100%;
                }
            }
        }


    }
}

@media (max-width: 1075px) {
    .payment-complete-content {
        .kit-arrival {
            .media-wrapper {
                flex-direction: column;
                padding-bottom: 28px;
                text-align: center;

                img {
                    width: 100%;
                    max-width: 100%;
                }

                .kit-arrival__content {
                    width: 100%;

                    .kit-arrival__copy {
                        max-width: 100%;
                    }
                }
            }
        }

        .kit-arrival__info {
            .info-copy {
                max-width: 420px;
            }
        }
    }
}

@include tablet() {
    .payment-complete-content {
        padding: 32px 10px;
    }

    .payment-complete-content .kit-arrival__info .info-icon-wrapper {
        display: none;
    }

    .step-header-title {
        font-size: 20px;
        font-weight: 700;
        line-height: 29px;
    }

    .header-content {
        font-size: 20px;
        line-height: 30px;
        font-weight: 700;
    }

    .header-image {
        width: 20px;
        margin-right: 15px;
    }

    .header-image__circle {
        width: 24px;
    }

    .green-header {
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 145%; /* 26.1px */
        letter-spacing: -0.18px;
    }

    .complete-content {
        margin-left: 0;
    }

    .payment-complete-content {
        .billing-info {

            img {
                display: none;
            }

            .billing-info__content {

                h3 {
                    font-size: 20px;
                }

                p {
                    font-size: 16px;
                }
            }
        }
    }
}

@include sm() {
    .payment-complete-header {
        font-size: 16px;
        padding: 24px 10px;
    }

    .payment-complete-header .collection-kit {
        font-size: 18px;
    }

    .payment-complete-content h2.large {
        font-size: 24px;
    }

    .payment-complete-content .billing-info {
        padding: 24px 10px;
    }

    .payment-complete-content .media-wrapper {
        padding: 24px 10px;
    }

    .payment-complete-content .media-wrapper .kit-arrival__copy {
        font-size: 16px;
    }

    .subtext {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 137.5% */
        margin-left: 0;
    }
}
</style>
